module.exports = [{
      plugin: require('/var/lib/jenkins/workspace/cloud-frontend-patient-2_master/node_modules/gatsby-plugin-use-query-params/gatsby-browser.js'),
      options: {"plugins":[]},
    },{
      plugin: require('/var/lib/jenkins/workspace/cloud-frontend-patient-2_master/gatsby-browser.js'),
      options: {"plugins":[]},
    }]
